var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRejeem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76,
    height: 84,
    viewBox: "0 0 76 84",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 70.665C1.39939 78.2523 8.04907 84 16.0412 84H32.9527L20.2657 65.6429C19.9215 65.6474 19.5754 65.6497 19.2273 65.6497H0V70.665Z",
    fill: "#E7E8E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 48.1134H18C24.8182 48.1134 29.9091 46.6634 33.2727 43.7633C36.6363 40.7727 38.3182 36.6945 38.3182 31.5288C38.3182 26.2724 36.6363 22.1942 33.2727 19.2942C29.9091 16.3941 24.8182 14.9441 18 14.9441H0V48.1134Z",
    fill: "#E7E8E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2273 -3C27.7727 -3 35.1363 -1.59529 41.3182 1.21414C47.5 3.93294 52.2727 7.8752 55.6363 13.0409C59 18.2066 60.6818 24.3692 60.6818 31.5288C60.6818 38.5976 59 44.7149 55.6363 49.8806C52.2727 54.9557 47.5 58.8527 41.3182 61.5715C41.2559 61.5989 41.1935 61.6261 41.131 61.6532L56.7519 84H70.6877C79.6968 84 87 76.6966 87 67.6874V13.3126C87 4.30342 79.6967 -3 70.6877 -3H19.2273Z",
    fill: "#E7E8E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejeem);
export default __webpack_public_path__ + "static/media/rejeem.40a2f470d4dca9a23217f2c8ca96a0be.svg";
export { ForwardRef as ReactComponent };